import React from 'react';
import './ProjectHighlight.css';
import icon1 from '../../../../assets/images/projectHighlights/icon1.svg';
import icon2 from '../../../../assets/images/projectHighlights/icon2.svg';
import icon3 from '../../../../assets/images/projectHighlights/icon3.svg';
import icon4 from '../../../../assets/images/projectHighlights/icon4.svg';

import bg from "../../../../assets/images/projectHighlights/bg.webp"
import { Link } from 'react-router-dom';


const ProjectHighlight = () => {
  return (
    <section className="project">

      <img src={bg} alt="" className="project-bg" />
      <div className="project-overlay"></div>

      <div className="project-container">

        <div className="project-top">

          <div className="project-title">
            <h2>Project<br />Highlights</h2>
          </div>

          <div className="project-cards">
            <div className="cardph">EU-GMP Aligned Facility</div>
            <div className="cardph">Dedicated Manufacturing Buildings</div>
            <div className="cardph">Intelligent integrated design</div>
            <div className="cardph">Comprehensive quality assurance...</div>
            <div className="cardph">Regional Market Expansion Potential</div>
            <Link to="/manufacture" className="cardph">
              Learn More <span className='arrowphg'></span>
            </Link>
          </div>

        </div>

        {/* Divider */}
        <div className="divider"></div>

        {/* BOTTOM SECTION */}
        <div className="project-bottom">

          <h2 className="cap-title">Manufacturing Capabilities</h2>

          <div className="cap-grid">

            <div className="cap-card">
              <div className='cap-card-top'>
                <h3>Sterile Injectables</h3>
                <div className='iconwrapperph'>
                  <img src={icon1} alt="" />
                </div>
              </div>
              <p>Small volume parenteral injectable production.</p>
            </div>

            <div className="cap-card">
              <div className='cap-card-top'>
                <h3>Oral Solid Dosage</h3>
                <div className='iconwrapperph'>
                  <img src={icon2} alt="" />
                </div>
              </div>
              <p>High-capacity tablet and capsule manufacturing.</p>
            </div>

            <div className="cap-card">
              <div className='cap-card-top'>
                <h3>Oral Liquid Formulations</h3>
                <div className='iconwrapperph'>
                  <img src={icon3} alt="" />
                </div>
              </div>
              <p>Syrups, suspensions, and oral solutions.</p>
            </div>

            <div className="cap-card">
              <div className='cap-card-top'>
                <h3>Biologic Production</h3>
                <div className='iconwrapperph'>
                  <img src={icon4} alt="" />
                </div>
              </div>
              <p>Advanced biosimilar and recombinant product manufacturing.</p>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default ProjectHighlight;